<template>
    <div class="modal fade" :class="{ in: isShowModal, active: isShow}"
        tabindex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true" v-show="isShow">
        <div class="modal-bg" @click="onModalClose"></div>
        <div class="modal-dialog">
            <div class="modal-content">
                <div class="common-modal-close" data-dismiss="modal" aria-label="Close" @click="onModalClose">
                    <img class="common-modal-close" src="https://resource.rcclchina.com.cn/TUI2PCImg/SearchPackage/modal-close.jpg">
                </div>

                <div class="modal-body modal-scroll  modal-text-center">
                  <div class="pay-shore">
                        <!--左侧 预定皇家岸上观光的三大理由-->
                        <div class="shore-content">
                            <div class="shore-reason">
                                <img src="https://resource.rcclchina.com.cn/shorex/shorex-title.png" alt="Alternate Text"
                                    style="width: 100%;">
                                <div class="shore-title">请在线升级付费精品游套餐</div>
                                <div class="good-products">
                                    <ul>
                                        <template v-for="(shorex, i) in shorexes">
                                            <li v-if="shorex.outOfStock == false" :key="('shorex_'+i)">
                                                <div class="price-title">
                                                    <RcclCheckBox
                                                        :ref="'shorexCheckBox'+shorex.id"
                                                        v-on:onChanged="onShorexSelected"
                                                        :customItem="shorex.id+''"/>
                                                    <span class="title-1">{{shorex.shorexName}}</span>
                                                    <span class="title-2">价格:{{shorex.price}}美元/每人 (上船自动房卡扣款)</span>
                                                </div>
                                                <div class="order-intro" v-for="(tour, j) in shorex.shorexTours" :key="('tour_'+i+'_'+j)">
                                                    <div class="shorex-trip-image">
                                                        <img :src="tour.image">
                                                    </div>
                                                    <div class="order-explain">
                                                        <div class="ex-title">{{tour.shorexName}}-{{tour.duration}}</div>
                                                        <div class="order-parah"  v-html="tour.shorexDescription"></div>
                                                        <div class="order-parah"  v-html="tour.introWarningText"></div>
                                                    </div>
                                                </div>
                                            </li>
                                        </template>

                                    </ul>
                                </div>
                                <div class="order-notice">
                                    <div class="notice">注:</div>
                                    <div class="tiny">
                                        <div><span class="parah-num">1)</span>目的地的产品及行程仅供参考，实际行程以具体航次和地接社安排为准。</div>
                                        <div><span class="parah-num">2)</span>目的地产品及行程可能受天气、航次情况、交通、政府政策及或保护公共健康安全之相关要求而取消、变更或调整。</div>
                                        <div><span class="parah-num">3)</span>皇家行前订目前只提供全程观光优惠套餐。您可于登船后购买单一港口观光产品。优惠套餐与单一港口观光产品均数量有限，先到先得。</div>
<!--                                        <div><span class="parah-num">3)</span>关于岸上观光产品的咨询、预订和修改，您可以拨打400-820-3187和皇家加勒比游轮度假专家联系。</div>-->
                                    </div>
                                </div>
                                <div class="order-btns">
                                    <div class="btn-item" data-dismiss="modal" @click="onModalClose">暂不修改</div>
                                    <div class="btn-item again selectShorexBtn" @click="submitShorex">
                                        <span>
                                            修改精品游
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import api from '@/api'
const RcclCheckBox = () => import('@/components/Common/RcclCheckBox')
export default {
    name: "BookingDetailShorex",
    components: {
        RcclCheckBox
    },
    props: {
        shorexes: {
            type: Array
        },
        booking: {
            type: Object
        },
        onSelectShorex: {
            type: Function
        },
        isShow: {
            type: Boolean
        }
    },
    data () {
        return {
            selectedShorexId: 0,
            isShowModal: false
        }
    },
    methods: {
        onModalClose () {
            this.isShowModal = false
            setTimeout(()=> {
                this.$emit('onModalClose')
            }, 100)
        },
        async submitShorex() {
            const requestData = {
                viewModel: [{
                    bookingId: this.booking.bookingId,
                    shorexId: this.selectedShorexId
                }]
            }
            this.$loading.show()
            const { success, errMsg } = await api.booking.selectShorex(requestData)
            this.$loading.hide()
            if (success) {
                this.$alert.show('修改成功', {
                    confirmCallBack: ()=> {
                        this.onSelectShorex(this.selectedShorex)
                    }
                })
            }else{
                if (errMsg && errMsg.length > 0) {
                    this.$alert.show(errMsg)
                }
            }
            console.error(errMsg)
        },
        onShorexSelected (isChecked, shorexIdStr) {
            // 寻缓关闭所有的按钮
            this.shorexes.forEach(v=>{
                let arrShorex = this.$refs['shorexCheckBox'+v.id]
                setTimeout(() => {
                    if (arrShorex && arrShorex.length > 0) {
                        arrShorex[0].isChecked = false
                    }
                }, 10)
            })

            // 打开当前状态
            let arr = this.$refs['shorexCheckBox'+shorexIdStr]
            setTimeout(() => {
                if (arr && arr.length > 0) {
                    arr[0].isChecked = true
                }
            }, 10)
            console.log(arr,'arrrrrrr')
            
            if (!isChecked) {
                this.selectedShorexId = 0
            } else {
                const shorexId = parseInt(shorexIdStr)
                if (isNaN(shorexId)) return
                this.selectedShorexId = shorexId
            }
        }
    },
    computed: {
        selectedShorex () {
            return this.shorexes.find(r=>r.id == this.selectedShorexId)
        },
        amount () {
            if (!this.booking || !this.booking.bookingGuests
            || !this.selectedShorex || !this.selectedShorex.price) return 0
            return this.selectedShorex.price * this.booking.bookingGuests.length
        }
    },
    watch: {
        shorexes (newValue) {
            if (newValue && newValue.length > 0) {
                this.selectedShorexId = newValue[0].id
            }
        },
        isShow (newValue) {
            setTimeout(()=> {
                this.isShowModal = newValue
            }, 100)
        }

    }
}
</script>


<style lang="less" scoped>
.modal-body {
    padding: 20px;
    text-align: center;
}
.modal-dialog {
    top: 5%;
    width: 1000px;
}

.modal.active {
    display: block;
}

.modal-bg {
    position: fixed;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    background-color: rgba(0, 0, 0, 0.5);
}

.modal {
    overflow: scroll;
    .common-modal-close {
        position: absolute;
        width: 28px;
        top: 3px;
        right: 5px;
        z-index: 2;
        cursor: pointer;
    }
}

.pay-shore {
    margin: 0 auto;
    display: block;
    justify-content: space-between;
    position: relative;
    .shore-content {
        background: #fff;
        padding: 24px 24px 38px 24px;
        border-radius: 25px;
        .parah-num {
            display: inline-block;
            width: 20px;
        }
        .shore-title {
            color: #006ab9;
            font-size: 20px;
            font-weight: bold;
            margin-bottom: 20px;
            text-align: center;
        }
        .good-products {
            padding-top: 42px;
            border-top: 1px solid #d3dadd;
            border-bottom: 1px solid #d3dadd;
            .price-title {
                display: flex;
                position: relative;
                text-align: left;
                .title-1 {
                    font-size: 20px;
                    font-weight: 400;
                    color: #282b2c;
                    margin-left: 30px;
                    display: inline-block;
                    width: 279px;
                }
                .title-2 {
                    font-size: 20px;
                    font-weight: 400;
                    color: #041455;
                }
            }
            .order-intro {
                margin-top: 36px;
                margin-left: 50px;
                margin-bottom: 36px;
                display: flex;
                .shorex-trip-image {
                    width: 250px;
                    display: inline-block;
                    vertical-align: top;
                    img {
                        width: 100%;
                    }
                }
                .order-explain {
                    margin-left: 30px;
                    display: inline-block;
                    vertical-align: top;
                    width: 560px;
                    text-align: left;
                    .ex-title {
                        font-weight: 400;
                        font-size: 15px;
                        color: #282b2c;
                        margin-bottom: 8px;
                    }
                    .order-parah {
                        line-height: 20px;
                        font-size: 14px;
                        color: #5a5a5a;
                        font-weight: 400;
                    }
                }
            }
        }
        .order-notice {
            // display: flex;
            margin-top: 20px;
            color: #747d80;
            font-weight: 500;
            margin-bottom: 26px;
            text-align: left;
            .notice {
                margin-right: 12px;
            }
        }

        .order-btns {
            width: 318px;
            margin: 0 auto;
            display: flex;
            justify-content: space-between;
            .btn-item {
                width: 148px;
                height: 40px;
                border: 1px solid #d3dadd;
                line-height: 40px;
                font-size: 14px;
                text-align: center;
                color: #333;
                cursor: pointer;
            }
            .again {
                background: #fbc500;
            }
        }
    }
}

</style>
